import { render } from "./rates_billing.html?vue&type=template&id=50bd4a74&external"
import script from "./rates_billing.js?vue&type=script&lang=js&external"
export * from "./rates_billing.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__